import React from 'react';
import Loading from 'react/components/Loading';

function LoadingLogin() {

  return (
    <div id="Login">
      <div id="LoginBox">
        <img
          className="login-greenmile-logo"
          alt="brand"
          src={require('static/images/brand.svg')}
          width="190"
          height="48"
          role="presentation"
        />
        <Loading height="150px"/>
      </div>
    </div>
  );
}

export default LoadingLogin;
